export default __webpack_public_path__ + "static/media/2.b3a45750.jpg";